import { Link } from "react-router-dom";

export function BkgLogo({ to = "/", testId = "brand-logo-link", className = "" }) {
  return (
    <Link to={to} data-testid={testId} className={`group flex w-fit items-center gap-3 ${className}`}>
      <span className="relative grid h-11 w-11 shrink-0 place-items-center" aria-hidden="true">
        <span className="absolute inset-0 rotate-45 border-2 border-volt transition-transform duration-700 ease-out group-hover:rotate-[225deg]" />
        <span className="absolute inset-[7px] rotate-45 border border-neon/60 transition-transform duration-700 ease-out group-hover:-rotate-[135deg]" />
        <span className="h-2.5 w-2.5 rounded-full bg-volt shadow-[0_0_14px_rgba(204,255,0,0.9)]" />
      </span>
      <span className="leading-none">
        <span className="block font-heading text-2xl font-black italic tracking-tight">
          BKG<span className="text-volt">.</span>
        </span>
        <span className="mt-1 block font-subheading text-[9px] font-bold uppercase tracking-[0.42em] text-zinc-500 transition-colors group-hover:text-volt">
          Global
        </span>
      </span>
    </Link>
  );
}
